import { v4 as uuidv4 } from 'uuid';

declare global {
  interface Window {
    ASAPP: any;
  }
}

export const setupASAPP = (loginHandler: Function) => {
  const asappTrackingId = sessionStorage.getItem('asappTrackingId');
  if (!asappTrackingId) {
    sessionStorage.setItem('asappTrackingId', uuidv4());
  }

  const urlParams = new URLSearchParams(window.location.search);
  const chat_intent = urlParams.get('chat_intent');
  const chat_source = urlParams.get('chat_source');
  const reducerSnapshot = JSON.parse(
    sessionStorage.getItem('persist:root') || 'null'
  );

  const ASAPP_TEST_PATH = 'dish-demo.test.asapp.com';
  const ASAPP_PROD_PATH = 'dish-sdk.asapp.com';
  const APPID_TEST = 'dish-sandbox';
  const APPID_PROD = 'dish';

  const ASAPPUrl =
    window.location.hostname === 'my.dish.com'
      ? ASAPP_PROD_PATH
      : ASAPP_TEST_PATH;
  const app_id =
      window.location.hostname === 'my.dish.com'
          ? APPID_PROD
          : APPID_TEST;

  let userInfo: any = null;
  if (reducerSnapshot?.userInfoData) {
    userInfo = JSON.parse(reducerSnapshot.userInfoData);
  }

  let customer_id = '';
  let auth_token = '';
  let refresh_token = '';
  if (userInfo) {
    customer_id = userInfo.accountNumber || '';
    auth_token = userInfo.authToken || '';
    refresh_token = userInfo.refreshToken || '';
  }

  let chatReady;

  const scripts = document.getElementsByTagName('script');
  let scriptExists = false;
  Array.from(scripts).forEach((script: HTMLScriptElement) => {
    if (script.src.includes('https://sdk.asapp.com')) {
      scriptExists = true;
    }
  });
  // download ASAPP SDK & create ASAPP function to interface with it
  if (!scriptExists) {
    (function (w: any, d: any, h: any, n: any, s?: any) {
      s = d.createElement('script');
      (w[n] =
        w[n] ||
        function () {
          (w[n]._ = w[n]._ || []).push(arguments);
        }),
        (w[n].Host = h),
        (s.async = 1),
        (s.src = `${h}/chat-sdk.js`),
        (s.type = 'text/javascript'),
        d.body.appendChild(s);
    })(window, document, 'https://sdk.asapp.com', 'ASAPP');

    document.addEventListener('click', (e: any) => {
      if (e.currentTarget?.activeElement?.className?.includes('chatbutton')) window.ASAPP('show');
    });
    document.addEventListener('keypress', (e: any) => {
      if (
        e.currentTarget?.activeElement?.className?.includes('chatbutton') &&
        (e.key === 'Enter' || e.key === ' ')
      )
        window.ASAPP('show');
    });
  }

  if (!userInfo?.fiberCustomer && window.ASAPP) {
    window.ASAPP('load', {
      APIHostname: ASAPPUrl,
      AppId: app_id,
      CustomerId: customer_id,
      Intent: chat_intent,
      Display: {
        BadgeColor: '#F01446',
        BadgeText: 'Chat With Us',
        AlwaysShowMinimize: true,
      },
      ContextProvider(callback: Function) {
        const context = {
          Auth: { Token: auth_token, RefreshToken: refresh_token },
          CustomerInfo: { Source: chat_source },
          ExternalSessionId: asappTrackingId,
          ExternalSessionType: 'UUID',
        };
        callback(context);
      },
      onLoadComplete: () => {
        chatReady = true;
      },
      UserLoginHandler() {
        if (loginHandler) {
          loginHandler();
        } else {
          // @ts-ignore
          document.getElementsByClassName('signInIcon')[0].click();
        }
      },
    });
  }

  if (chatReady === true && window.ASAPP) {
    window.ASAPP('show');
  }
};

export const setASAPPCustomer = (userInfo?: any) => {
  if (window.ASAPP) {
    const urlParams = new URLSearchParams(window.location.search);
    const chat_intent = urlParams.get('chat_intent');
    const chat_source = urlParams.get('chat_source');
    const reducerSnapshot = JSON.parse(
      sessionStorage.getItem('persist:root') || 'null'
    );

    if (userInfo) {
      window.ASAPP('setCustomer', {
        CustomerId: userInfo.accountNumber,
        Intent: chat_intent,
        ContextProvider: (callback: Function) => {
          const context = {
            Auth: {
              Token: userInfo.authToken,
              RefreshToken: userInfo.refreshToken,
            },
            CustomerInfo: { Source: chat_source },
            ExternalSessionId: sessionStorage.getItem('asappTrackingId') || '',
            ExternalSessionType: 'UUID',
          };
          callback(context);
        },
      });
    }
  }
};
